<template>
  <v-layout justify-center>
    <v-dialog v-model='productmodal' max-width="500">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="productmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout row wrap justify-center>
            <v-flex xs10 sm8 md8 lg8>
              <v-file-input
                  label="Upload image"
                  prepend-icon="mdi-camera"
                  v-model="files"
                  accept="image/*"
                  @change="onChangeFileUpload()"
                  color="pink lighten-2"
                ></v-file-input>
                <v-layout justify-center>
                  <v-hover v-slot:default="{ hover }">
                      <v-img v-if="url" :src="url" class="grey lighten-2" max-width="200" max-height="200">
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-slow-out  v-card--reveal black--text"
                            style="height: 100%;"
                          >
                            <v-layout justify-end style="height: 100%;">
                              <p class="px-2" style="font-size: 18px; cursor: pointer;" @click="removeimage()"><strong>x</strong></p>
                            </v-layout>
                          </div>
                        </v-expand-transition>
                      </v-img>
                  </v-hover>
                  <!-- <v-img v-if="url" :src="url" class="grey lighten-2" max-width="200" max-height="200"/> -->
                </v-layout>
              <br />
              <v-layout row wrap align-center hidden-sm-and-down>
                <v-flex xs12 sm3 md3 lg3>
                  <p class="label">รหัสซื้อขาย</p>
                </v-flex>
                <v-flex xs12 sm9 md9 lg9>
                <v-text-field v-model="product_no" required style='display:inline;' :rules="rules" color="pink lighten-2"
                ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2 lg2>
                  <p class="label">ชื่อสินค้า</p>
                </v-flex>
                <v-flex xs0 sm1 md1 lg1></v-flex>
                <v-flex xs12 sm9 md9 lg9>
                <v-text-field v-model="name" required :rules="[v => !!v || 'กรุณากรอกชื่อสินค้า']" style='display:inline;' color="pink lighten-2"
                ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2 lg2>
                  <p class="label">ราคา</p>
                </v-flex>
                <v-flex xs0 sm1 md1 lg1></v-flex>
                <v-flex xs12 sm9 md9 lg9>
                  <v-text-field v-model="price" required :rules="[v => Number(v.replace(/,/g, '')) > 0 || 'กรุณากรอกราคาสินค้า']" color="pink lighten-2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2 lg2>
                  <p class="label">ประเภท</p>
                </v-flex>
                <v-flex xs sm1 md1 lg1></v-flex>
                <v-flex xs12 sm9 md9 lg9>
                  <v-combobox
                    v-model="type"
                    :items="typeitems"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    color="pink lighten-2"
                  ></v-combobox>
                </v-flex>
              </v-layout>
              <!-- mobile -->
              <v-layout row wrap align-center hidden-md-and-up>
                <v-layout align-center>
                <v-flex xs3 sm2 md2 lg2>
                <p class="label">รหัสซื้อขาย</p>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9>
                <v-text-field v-model="product_no" required style='display:inline;' :rules="rules" color="pink lighten-2"
                ></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout align-center>
                <v-flex xs3 sm2 md2 lg2>
                  <p class="label">ชื่อสินค้า</p>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9>
                <v-text-field v-model="name" required :rules="[v => !!v || 'กรุณากรอกชื่อสินค้า']" style='display:inline;' color="pink lighten-2"
                ></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout align-center>
                <v-flex xs3 sm2 md2 lg2>
                  <p class="label">ราคา</p>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9>
                  <v-text-field v-model="price" required :rules="[v => Number(v) > 0 || 'กรุณากรอกราคาสินค้า']" color="pink lighten-2"
                  ></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout align-center>
                <v-flex xs3 sm2 md2 lg2>
                  <p class="label">ประเภท</p>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9>
                  <v-combobox
                    v-model="type"
                    :items="typeitems"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    color="pink lighten-2"
                  ></v-combobox>
                </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="productmodal = false">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
import swal from 'sweetalert'
export default {
  data () {
    return {
      title: 'เพิ่มสินค้า',
      currentdata: '',
      id: '',
      file: '',
      product_no: '',
      name: '',
      price: 0,
      type: 'ชิ้น',
      typeitems: [ 'ชิ้น', 'ถุง', 'กล่อง' ],
      url: null,
      files: null,
      rules: [v => v.length > 0 || 'กรุณากรอกรหัสซื้อขาย']
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    parentgetdata: ''
  },
  methods: {
    async save () {
      try {
        if (this.name !== '' && Number(this.price.replace(/,/g, '')) > 0) {
          let tempdata = {
            product_no: this.product_no,
            name: this.name,
            price: this.price,
            type: this.type,
            image: ''
          }
          tempdata = JSON.stringify(tempdata)

          let formdata = new FormData()
          formdata.append('body', tempdata)
          if (this.file) {
            formdata.append(`file`, this.file)
          }

          let swaltext = ''
          if (this.id) {
            await this.axios.put(`${process.env.VUE_APP_API}/product/edit/${this.id}`, formdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกการแก้ไขข้อมูลสินค้าเรียบร้อย'
          } else {
            await this.axios.post(`${process.env.VUE_APP_API}/product/add`, formdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            this.productmodal = false
            swaltext = 'บันทึกข้อมูลสินค้าใหม่เรียบร้อย'
          }
          this.productmodal = false
          await swal(swaltext, {
            icon: 'success',
            buttons: 'ตกลง'
          })
          this.parentgetdata()
        } else {
          await swal({
            title: `กรุณากรอกข้อมูลให้ถูกต้องและครบถ้วน`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            title: `รหัสซื้อขายนี้มีอยู่แล้วในระบบ`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        } else {
          await swal({
            title: `ระบบผิดพลาด`,
            text: 'กรุณาลองอีกครั้งในภายหลัง',
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      }
    },
    onChangeFileUpload () {
      if (this.files !== null) {
        this.file = this.files
        this.url = URL.createObjectURL(this.file)
      } else {
        this.file = ''
        this.url = ''
      }
    },
    removeimage () {
      this.files = null
      this.file = null
      this.url = null
    }
  },
  computed: {
    productmodal: sync('productmodal'),
    currentproductdata: sync('currentproductdata')
  },
  watch: {
    currentproductdata () {
      if (this.currentproductdata !== '') {
        this.currentdata = JSON.parse(this.currentproductdata)
        this.id = this.currentdata._id
        this.product_no = this.currentdata.product_no
        this.name = this.currentdata.name
        this.price = this.currentdata.price
        this.type = this.currentdata.type
        this.url = this.currentdata.image
        this.title = 'แก้ไขสินค้า'
        this.files = null
      } else {
        this.currentdata = ''
        this.id = ''
        this.product_no = ''
        this.name = ''
        this.price = 0
        this.url = ''
        this.title = 'เพิ่มสินค้า'
      }
    }
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
p.label {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  color: #787878;
}
.inputstyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
}
.v-text-field {
  font-family: 'Kanit';
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-list-item__title {
  font-family: 'Kanit';
}
.v-dialog {
  overflow-x: hidden;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>
